export { default as ColorInfo } from './ColorInfo';
